export class SearchFilterModel {
    instanceHashId: string = '';
    companyHashId: string = '';
    organizationHashId: string = '';
    sharedVehicleGroupHashId: string='';
    searchInstanceList: string[] = [];
    searchCompanyList: string[] = [];
    searchOrganizationList: string[] = [];
    searchSharedVehicleGroupList: string[] = [];
    InstanceHashIdList: string[] =[''];
    CompanyHashIdList: string[] = [''];
    OrganizationHashIdList: string[] = [''];
    SharedVehicleGroupHashIdList: string[] = [''];
    keyHash: string[] = [''];
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/models/search-filter.model.ts